import React, { useMemo } from 'react';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import useTokenReplacement from 'hooks/custom/useTokenReplacement';
import { FooterLinkItem } from 'types';
import FooterLink from './FooterLink';
import SocialLinks, { SocialLinkItem } from './SocialLinks';

interface DefaultSiteFooterProps {
  siteName?: string;
  footerText?: string;
  footerLinks?: FooterLinkItem[];
  socialLinks?: SocialLinkItem[];
  socialLinksTitle?: string;
}

function DefaultSiteFooter({
  siteName,
  footerText = '',
  footerLinks,
  socialLinks,
  socialLinksTitle,
}: DefaultSiteFooterProps): React.ReactElement | null {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const tokenizedWysiwygText = useTokenReplacement(footerText);

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner">
        <div className="footer__branding">
          <div className="footer__logo">
            <span className="isVisuallyHidden">{siteName}</span>
          </div>
          {socialLinks && socialLinks.length > 0 && (
            <div className="footer__social">
              <SocialLinks
                socialLinks={socialLinks}
                socialLinksTitle={socialLinksTitle}
              />
            </div>
          )}
        </div>
        <div className="footer__text" suppressHydrationWarning>
          <Wysiwyg content={tokenizedWysiwygText} isReversed />

          {footerLinks && (
            <ul className="footer__links">
              {footerLinks.map((footerLink) => (
                <li key={footerLink.link} className="footer__linkItem">
                  <FooterLink
                    link={footerLink.link}
                    label={footerLink.label}
                    trigger={footerLink.trigger}
                  />
                </li>
              ))}
            </ul>
          )}
          <div className="footer__attribution" suppressHydrationWarning>
            {`© ${currentYear} `}
            <a
              href="https://www.triadms.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              TriAd Media Solutions, Inc.
            </a>
            {' All Rights Reserved'}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default DefaultSiteFooter;
